import styled from "styled-components";

const Column = styled.div`
  display: flex;
  align-items: center;
  height: 54px;
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  padding-right: 10px;
`

export default Column;
